
<template>
  <div>
    <Charts @update-details="updateDetails" />
    <vs-row>
      <vs-col vs-lg="12" vs-sm="12">
        <vs-row class="mt-1">
          <vs-col vs-lg="4" vs-sm="12" class="p-3">
            <vs-row class="p-5 dashboardCardsClr">
              <vs-row vs-justify="space-between">
                <div class="my-1">
                  <vs-row vs-justify="space-between">
                    <div class="circle my-1"></div>
                    <div>
                      <div
                        class="
                          ml-0
                          pl-0
                          m-3
                          ml-3
                          displayInlineCard
                          font-semibold
                        "
                        vs-lg="12"
                      >
                        {{ details.totalAccounts }}
                      </div>
                      <div class="mt-0 ml-3 mt-2 fontS15">Total Accounts</div>
                    </div>
                  </vs-row>
                </div>
              </vs-row>
            </vs-row>
          </vs-col>

          <vs-col vs-lg="4" vs-sm="12" vs-xs="12" class="p-3">
            <vs-row class="p-5 dashboardCardsClr">
              <vs-row vs-justify="space-between" class="cardCircle">
                <vs-row vs-justify="flex-end">
                  <vs-dropdown class="selectListCard pt-1" vs-trigger-click>
                    <vs-row class="a-icon">
                      Last {{ selectedAccount }} Days
                      <div class="pt-1 pl-1">
                        <vs-icon icon="expand_more"></vs-icon>
                      </div>
                    </vs-row>

                    <vs-dropdown-menu>
                      <vs-dropdown-item @click="setSelectedAccount(7)">
                        Last 7 Days
                      </vs-dropdown-item>
                      <vs-dropdown-item @click="setSelectedAccount(30)">
                        Last 30 Days
                      </vs-dropdown-item>
                      <vs-dropdown-item @click="setSelectedAccount(90)">
                        Last 90 Days
                      </vs-dropdown-item>
                    </vs-dropdown-menu>
                  </vs-dropdown>
                </vs-row>
                <div class="my-1">
                  <vs-row vs-justify="space-between">
                    <div class="acircle my-1"></div>
                    <div>
                      <div
                        class="ml-3 displayInlineCard font-semibold"
                        vs-lg="12"
                      >
                        {{ details.newAccounts }}
                      </div>
                      <div class="mt-0 ml-3 mt-2 fontS15">New Accounts</div>
                    </div>
                  </vs-row>
                </div>
              </vs-row>
            </vs-row>
          </vs-col>
          <vs-col vs-lg="4" vs-sm="12" class="p-3">
            <vs-row class="p-5 dashboardCardsClr">
              <vs-row vs-justify="space-between">
                <div class="my-1">
                  <vs-row vs-justify="space-between">
                    <div class="circle my-1"></div>
                    <div>
                      <div
                        class="
                          ml-0
                          pl-0
                          m-3
                          ml-3
                          displayInlineCard
                          font-semibold
                        "
                      >
                        {{ details.newMessages }}
                      </div>
                      <div class="mt-0 ml-3 mt-2 fontS15">New Messages</div>
                    </div>
                  </vs-row>
                </div>
              </vs-row>
            </vs-row>
          </vs-col>
          <vs-col vs-lg="4" vs-sm="12" class="p-3">
            <vs-row class="p-5 dashboardCardsClr">
              <vs-row vs-justify="space-between">
                <div class="my-1">
                  <vs-row vs-justify="space-between">
                    <div class="circle my-1"></div>
                    <div>
                      <div
                        class="
                          ml-0
                          pl-0
                          m-3
                          ml-3
                          displayInlineCard
                          font-semibold
                        "
                        vs-lg="12"
                      >
                        {{ details.totalProfiles }}
                      </div>
                      <div class="mt-0 ml-3 mt-2 fontS15">Total Profiles</div>
                    </div>
                  </vs-row>
                </div>
              </vs-row>
            </vs-row>
          </vs-col>

          <vs-col vs-lg="4" vs-sm="12" vs-xs="12" class="p-3">
            <vs-row class="p-5 dashboardCardsClr">
              <vs-row vs-justify="space-between" class="cardCircle">
                <vs-row vs-justify="flex-end">
                  <vs-dropdown class="selectListCard pt-1" vs-trigger-click>
                    <vs-row class="a-icon">
                      Last {{ selectedProfile }} Days
                      <div class="pt-1 pl-1">
                        <vs-icon class="" icon="expand_more"></vs-icon>
                      </div>
                    </vs-row>

                    <vs-dropdown-menu>
                      <vs-dropdown-item @click="setSelectedProfile(7)">
                        Last 7 Days
                      </vs-dropdown-item>
                      <vs-dropdown-item @click="setSelectedProfile(30)">
                        Last 30 Days
                      </vs-dropdown-item>
                      <vs-dropdown-item @click="setSelectedProfile(90)">
                        Last 90 Days
                      </vs-dropdown-item>
                    </vs-dropdown-menu>
                  </vs-dropdown>
                </vs-row>
                <div class="my-1">
                  <vs-row vs-justify="space-between">
                    <div class="acircle my-1"></div>
                    <div>
                      <div
                        class="ml-3 displayInlineCard font-semibold"
                        vs-lg="12"
                      >
                        {{ details.newProfiles }}
                      </div>
                      <div class="mt-0 ml-3 mt-2 fontS15">New Profiles</div>
                    </div>
                  </vs-row>
                </div>
              </vs-row>
            </vs-row>
          </vs-col>

          <vs-col vs-lg="4" vs-sm="12" vs-xs="12" class="p-3">
            <vs-row class="p-4 dashboardCardsClr">
              <vs-row vs-justify="space-between">
                <div class="my-1 w-full mt-2">
                  <vs-row>
                    <div class="dEmptyCircle my-1 ml-1"></div>
                    <div class="cardAdjust">
                      <div
                        class="
                          ml-0
                          pl-0
                          m-3
                          ml-3
                          displayInlineCard
                          font-semibold
                        "
                      >
                        {{ details.pendingCards }}
                      </div>
                      <div class="mt-0 pl-3 mt-1 pb-2 fontS15">
                        Cards Pending Approval
                      </div>
                    </div>
                  </vs-row>
                </div>
              </vs-row>
            </vs-row>
          </vs-col>
        </vs-row>
      </vs-col>
      <vs-row>
        <vs-col vs-lg="6" vs-sm="12" class="p-3 pt-4">
          <div class="p-5 dashboardCardsClr">
            <vs-row>
              <h4 class="my-5 mb-3 ml-4 font-semibold">Top Credit Cards</h4>
            </vs-row>
            <vs-row>
              <vs-col>
                <vs-row
                  :key="index"
                  v-for="(cards, index) in cardsList"
                  class="my-2 p-2 pl-0"
                >
                  <div v-if="index + 1 < 10" class="dcircle my-2 ml-1">
                    <div class="my-3 pl-0">{{ index + 1 }}</div>
                  </div>
                  <div v-if="index + 1 >= 10" class="dcircle2 my-2 ml-1">
                    <div class="my-3 pl-0">{{ index + 1 }}</div>
                  </div>

                  <div class="mt-2 ml-4">
                    <vs-row vs-type="flex" vs-justify="flex-start">
                      <vue-load-image>
                        <img
                          class="image"
                          slot="image"
                          :src="
                            cards._id.photo
                              ? $ApiKeys.BASE_URL + cards._id.photo
                              : require('@/assets/images/default-images/default-profile.png')
                          "
                          width="77"
                          height="48"
                        />
                        <img
                          class="image"
                          slot="preloader"
                          src="@/assets/images/image-loader.gif"
                          width="77"
                          height="77"
                        />
                        <div slot="error">
                          <img
                            class="image"
                            slot="image"
                            :src="require('@/assets/images/no_preview.jpg')"
                            width="77"
                            height="48"
                          />
                        </div>
                      </vue-load-image>
                    </vs-row>
                  </div>

                  <div class="mt-3 ml-4 issuerWidth">
                    <h5 id="creditTextClr" class="mb-1 pl-0">
                      {{ cards ? cards._id.Issuername[0] : "N/A" }}
                    </h5>

                    <h6 class="textItems pl-0 font-semibold mt-0">
                      {{ cards ? cards._id.card : "No Credit Card Available" }}
                    </h6>
                  </div>

                  <div class="ml-auto pt-2">
                    <vs-row class="w-full" vs-type="flex" vs-justify="flex-end">
                      <h5>
                        {{ cards ? cards.cardUsageCount : 0 }}
                      </h5>
                    </vs-row>
                    <h5 id="creditTextClr" class="mt-2">Cards</h5>
                  </div>
                </vs-row>
              </vs-col>
            </vs-row>
          </div>
        </vs-col>
        <vs-col vs-lg="6" vs-sm="12" class="p-3 pt-4">
          <div class="p-5 dashboardCardsClr">
            <vs-row>
              <h4 class="my-5 mb-3 ml-4 font-semibold">Top Issuers</h4>
            </vs-row>
            <vs-row>
              <vs-col>
                <vs-row
                  :key="index"
                  v-for="(issuers, index) in issuersList"
                  class="my-2 p-2 pl-0"
                >
                  <div v-if="index + 1 < 10" class="dcircle my-2 ml-1">
                    <div class="my-3 pl-0">{{ index + 1 }}</div>
                  </div>
                  <div v-if="index + 1 >= 10" class="dcircle2 my-2 ml-1">
                    <div class="my-3 pl-0">{{ index + 1 }}</div>
                  </div>
                  <div class="mt-5 issuerWidth">
                    <h4 class="textItems pl-3 font-semibold mt-1">
                      {{
                        issuers ? issuers._id.issuer[0] : "No Issuer Available"
                      }}
                    </h4>
                  </div>
                  <div class="ml-auto pt-2">
                    <vs-row class="w-full" vs-type="flex" vs-justify="flex-end">
                      <h5>
                        {{ issuers ? issuers.cardsCount : 0 }}
                      </h5>
                    </vs-row>
                    <h5 id="creditTextClr" class="mt-2">Credit Cards</h5>
                  </div>
                </vs-row>
              </vs-col>
            </vs-row>
          </div>
        </vs-col>
      </vs-row>
        <vs-row>
        <vs-col vs-lg="6" vs-sm="12" class="p-3 pt-4">
          <div class="p-5 dashboardCardsClr">
            <vs-row>
              <h4 class="my-5 mb-3 ml-4 font-semibold">Users With Cards Added</h4>
            </vs-row>
            <vs-row>
              <vs-col>
                <vs-row
                  :key="index"
                  v-for="(info, index) in usersWithCardsAdded"
                  class="my-2 p-2 pl-0"
                >
                  <div v-if="index + 1 < 10" class="dcircle my-2 ml-1">
                    <div class="my-3 pl-0">{{ index + 1 }}</div>
                  </div>
                  <div v-if="index + 1 >= 10" class="dcircle2 my-2 ml-1">
                    <div class="my-3 pl-0">{{ index + 1 }}</div>
                  </div>
                  <div class="cardsAddedBlock mt-2">  
                    <vs-row class="mb-1">
                      <h4>
                        {{ info ? (info.count && (index==2 || index==3)?info.count.toFixed(3)+'%':info.count.toFixed(3)) : 0 }}
                      </h4>
                    </vs-row>
                    <vs-row>
                      <h6>
                      {{ info.heading ? info.heading : "No Credit Card Available" }}
                      </h6>
                    </vs-row>
                  </div>
                </vs-row>
              </vs-col>
            </vs-row>
          </div>
        </vs-col>
        <vs-col vs-lg="6" vs-sm="12" class="p-3 pt-4">
          <div class="p-5 dashboardCardsClr">
            <vs-row>
              <h4 class="my-5 mb-3 ml-4 font-semibold">Users With No Cards Added</h4>
            </vs-row>
            <vs-row>
              <vs-col>
                <vs-row
                  :key="index"
                  v-for="(info, index) in usersWithNoCardsAdded"
                  class="my-2 p-2 pl-0"
                >
               <div v-if="index + 1 < 10" class="dcircle my-2 ml-1">
                    <div class="my-3 pl-0">{{ index + 1 }}</div>
                  </div>
                  <div v-if="index + 1 >= 10" class="dcircle2 my-2 ml-1">
                    <div class="my-3 pl-0">{{ index + 1 }}</div>
                  </div>
                  <div class="cardsAddedBlock mt-1">  
                    <vs-row class="mb-2">
                      <h4>
                        {{ info ? info.count.toFixed(3) +'%' : 0 }}
                      </h4>
                    </vs-row>
                    <vs-row>
                      <h6>
                      {{ info.heading ? info.heading : "No Credit Card Available" }}
                      </h6>
                    </vs-row>
                  </div>
                </vs-row>
              </vs-col>
            </vs-row>
          </div>
        </vs-col>
      </vs-row>
    </vs-row>
  </div>
</template>

<script>
import Charts from "@/views/admin/charts/";
import { MenuIcon } from "vue-feather-icons";
import EventBus from "@/event-bus.js";
import { genericErrorMessage, toast } from "@/keys/toast-messages";
import VueLoadImage from "vue-load-image";
import { mixin as clickaway } from "vue-clickaway";

export default {
  components: {
    mixins: [clickaway],
    Charts,
    MenuIcon,
    VueLoadImage,
  },
  data() {
    return {
      selectedAccount: 7,
      selectedProfile: 7,
      options1: [
        { text: "Last 7 days", value: 7 },
        { text: "Last 30 days", value: 30 },
        { text: "Last 90 days", value: 90 },
      ],

      issuersList: [],
      cardsList: [],
      usersWithCardsAdded:[],
      usersWithNoCardsAdded:[],
      totalApprovals: 0,
      totalMessages: 0,
      userAddedPromos: 0,

      details: {
        totalAccounts: 0,
        newAccounts: 0,
        totalProfiles: 0,
        newProfiles: 0,
        newMessages: 0,
        pendingCards: 0,
        userAddedPromoCount: 0,
      },
      genericErrorMessage,
      toast,
    };
  },
  methods: {
    updateDetails(data) {
      this.details = {
        totalAccounts: data.totalAccounts,
        newAccounts: data.newAccounts,
        totalProfiles: data.totalProfiles,
        newProfiles: data.newProfiles,
        newMessages: data.newMessages,
        pendingCards: data.pendingCards,
        userAddedPromoCount: data.userAddedPromoCount,
      };
      this.issuersList = data.topIssuers;
      this.cardsList = data.topcards;
      this.usersWithCardsAdded=data.usersWithCardsAdded;
      this.usersWithNoCardsAdded=data.usersWithNoCardsAdded;

      EventBus.$emit("totalApprovals", data.pendingCards);
      EventBus.$emit("totalMessages", data.newMessages);
      EventBus.$emit("userAddedPromos", data.userAddedPromoCount);
    },
    setSelectedAccount(days) {
      this.selectedAccount = days;
      this.getNewAccounts();
    },
    setSelectedProfile(days) {
      this.selectedProfile = days;
      this.getNewProfiles();
    },
    getNewAccounts() {
      return new Promise((resolve, reject) => {
        this.$axios
          .get(this.$ApiKeys.BASE_URL + this.$EndPoints.NewAccountsCount, {
            params: {
              days: this.selectedAccount,
            },
            headers: {
              Authorization: this.$localStorage.get("token"),
            },
          })
          .then(async (res) => {
            if (res.data.success) {
              resolve((this.details.newAccounts = res.data.data.newAccounts));
            } else {
              this.toast(this.genericErrorMessage());
            }
          })
          .catch((e) => {
            if (e.response.status !== 401) {
              this.toast(this.genericErrorMessage());
            }
            // console.log("Error in getNewAccounts: ",e);
          });
      });
    },
    getNewProfiles() {
      return new Promise((resolve, reject) => {
        this.$axios
          .get(this.$ApiKeys.BASE_URL + this.$EndPoints.NewProfilesCount, {
            params: {
              days: this.selectedProfile,
            },
            headers: {
              Authorization: this.$localStorage.get("token"),
            },
          })
          .then(async (res) => {
            if (res.data.success) {
              resolve((this.details.newProfiles = res.data.data.newProfiles));
            } else {
              this.toast(this.genericErrorMessage());
            }
          })
          .catch((e) => {
            if (e.response.status !== 401) {
              this.toast(this.genericErrorMessage());
            }
            // console.log("Error in getNewProfiles: ",e);
          });
      });
    },
  },
  created() {
    EventBus.$emit("resetToggleGroup", true);
  },
};
</script>

<style>
@import "./style.css";
</style>